import Vue from 'vue';
import moment from 'moment';
import _ from 'underscore';

const roleTypes = {
	'clinic_admin': 'Администратор клиники',
	'registrar': 'Регистратура',
	'doctor': 'Доктор',
	'service_staff': 'Сотрудник',
	'device': 'Устройство',
	'client': 'Клиент'
};

const statuses = {
	'not_confirmed': 'Не подтвержден',
	'confirmed': 'Подтвержден',
	'came': 'Пришел',
	'canceled': 'Отменен',
	'not_appeared': 'Неявка',
	'completed': 'Завершен',

	'declared': 'Создана',
	'processed': 'Обработана',
	'disapproved': 'Отклонена'
};

const own_type = {
	'state': 'Государственная',
	'private': 'Частная'
};

const labels = {
	'yes': 'Принимает',
	'no': 'Не принимает',
	'by_request': 'По заявкам'
};

const sexConst = {
	male: 'Мужской',
	female: 'Женский'
};

Vue.filter('one', val => {
	if (val) return val.charAt(0) + '.';
});

Vue.filter('sex', (sex) => {
	return sexConst[sex];
});

Vue.filter('age', (date, format) => {
	let bd, years, length, humanWord;

	const yearVars = {
		'год': [1],
		'года': [2, 3, 4],
		'лет': [0, 5, 6, 7, 8, 9]
	};

	bd = moment(date, format || 'X');
	years = moment().diff(bd, 'years').toString();
	length = years.length - 1;

	humanWord = _(yearVars).findKey(item => {
		return (item.indexOf(+years[length]) !== -1);
	});

	return years + ' ' + humanWord;
});

Vue.filter('role', (role) => {
	return roleTypes[role];
});

Vue.filter('status', (value) => {
	return statuses[value] || 'Неизвестный статус';
});

Vue.filter('data', (value, format = 'DD.MM.YY') => {
	return moment(value, 'X').format(format);
});

Vue.filter('time', (value, from = 'X', format = 'HH:mm') => {
	return moment(value, from).format(format);
});

Vue.filter('type', (value) => {
	return own_type[value] || own_type['state'];
});

Vue.filter('can', (value) => {
	return labels[value] || 'Неизвестно';
});

Vue.filter('ago', (value) => {
	let now = moment();

	let diff = now.diff(moment(value, 'X'), 'minutes');

	if (diff < 60) {
		return diff + ' минут назад';
	} else if (diff < 1440) {
		let end = (diff < 120) ? '' : (diff < 300) ? 'а' : 'ов';

		return now.diff(moment(value, 'X'), 'hours') + ' час' + end + ' назад';
	} else if (diff >= 1440) {
		return now.diff(moment(value, 'X'), 'days') + ' дней назад';
	}
});

Vue.filter('reviewCase', (value = 0) => {
	let lastNumber = +value.toString().split('').pop();

	if (lastNumber === 0 || lastNumber >= 5) {
		return value + ' отзывов';
	} else if (lastNumber === 1) {
		return value + ' отзыв';
	} else if (lastNumber > 0 && lastNumber < 5) {
		return value + ' отзыва';
	} else {
		return '0 отзывов';
	}
});



// WEBPACK FOOTER //
// ./src/common/filters.js